
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/kaiho",
      function () {
        return require("private-next-pages/cases/kaiho/index.tsx");
      }
    ]);
  